/* eslint-disable @typescript-eslint/no-explicit-any */
import { Autocomplete, Divider, Grid, TextField } from "@mui/material";
import { ProductStockModel, TaxRateModel } from "../../Utils/Models";
import { onChangeTextField } from "../../Utils/Utils";
import { Vocabulary } from "../../Utils/Vocabulary";
import { Delete } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { getData } from "../../Services/getData";
import { urlEnum } from "../../Utils/UrlEnum";

type ProductStockListProps = {
  index: number;
  inventory: ProductStockModel;
  showDivider: boolean;
  handleChangeOneInventory: (index: number, inventory: any) => void;
};

export default function ProductStockList(props: ProductStockListProps) {
  const { index, inventory, showDivider, handleChangeOneInventory } = props;
  const [vatList, setVatList] = useState<Array<TaxRateModel>>([]);

  useEffect(() => {
    async function getVatList() {
      const result = (await getData(`${urlEnum.taxRates}`)).data;
      setVatList(result.result);
    }
    getVatList();
  }, []);
  return (
    <>
      <Grid
        container
        spacing={2}
        style={{
          margin: "20px 0px",
          padding: 0,
          display: "flex",
          alignItems: "center",
        }}
      >
        <Grid item xs={12} sm={2} md={2} lg={2}>
          {inventory.inventory?.name} <br />
          {inventory.inventory?.location?.name}
        </Grid>
        <Grid item xs={12} sm={2} md={2} lg={2}>
          {inventory.isNew ? (
            <TextField
              id="quantity"
              name="quantity"
              size="small"
              variant="outlined"
              type="number"
              fullWidth
              label={Vocabulary.quantity}
              value={inventory.quantity || 0}
              onChange={(event: any) => {
                const newInventory: any = Object.assign({}, inventory);
                newInventory.quantity = event.target.value;
                newInventory.totalPrice =
                  newInventory.quantity * newInventory.pricePerQuantity || 0;
                handleChangeOneInventory(index, newInventory);
              }}
            />
          ) : (
            inventory.quantity
          )}
        </Grid>
        <Grid item xs={12} sm={2} md={2} lg={2}>
          {inventory.isNew ? (
            <TextField
              id="pricePerQuantity"
              name="pricePerQuantity"
              size="small"
              variant="outlined"
              type="number"
              fullWidth
              label={Vocabulary.pricePerQuantity}
              value={inventory.pricePerQuantity || 0}
              onChange={(event: any) => {
                const newInventory: any = Object.assign({}, inventory);
                newInventory.pricePerQuantity = event.target.value;
                newInventory.totalPrice =
                  newInventory.quantity * newInventory.pricePerQuantity || 0;

                handleChangeOneInventory(index, newInventory);
              }}
            />
          ) : (
            inventory.pricePerQuantity
          )}
        </Grid>
        <Grid item xs={12} sm={2} md={2.5} lg={2.5}>
          {inventory.isNew ? (
            <Autocomplete
              size="small"
              options={vatList}
              getOptionLabel={(option: any) => option.name}
              onChange={(e: any, value: any) => {
                ("");
              }}
              style={{ marginBottom: 20, marginTop: 20 }}
              renderInput={(params) => (
                <TextField {...params} label={Vocabulary.vat} />
              )}
              fullWidth
            />
          ) : (
            inventory.quantity
          )}
        </Grid>
        <Grid item xs={12} sm={2.5} md={2.5} lg={2.5}>
          {inventory.isNew ? (
            <TextField
              id="totalPrice"
              name="totalPrice"
              size="small"
              variant="outlined"
              type="number"
              fullWidth
              label={Vocabulary.totalPrice}
              value={inventory.totalPrice || 0}
              onChange={(event: any) => {
                handleChangeOneInventory(
                  index,
                  onChangeTextField(event, inventory)
                );
              }}
            />
          ) : (
            inventory.totalPrice
          )}
        </Grid>
        <Grid
          item
          xs={12}
          sm={1}
          md={1}
          lg={1}
          style={{ verticalAlign: "middle", color: "red" }}
        >
          <Delete
            style={{ cursor: "pointer" }}
            onClick={() => {
              handleChangeOneInventory(index, null);
            }}
          />
        </Grid>
      </Grid>
      {showDivider ? <Divider /> : null}
    </>
  );
}
